(() => {
  const cache = new Map();
  const vendors=JSON.parse(document.getElementById('BizedealsSearchVendors')?.textContent||'[]');
  const brandedQuery=value=>window.BizedealsSearchQuery?.queryFor(value,vendors)||value;
  const historyKey = 'bizedeals.search.recent';
  const preferencesAllowed = () => window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true;
  const normalize = value => value.trim().replace(/\s+/g, ' ').slice(0, 200);
  function searchURL(form, query) {
    const url = new URL(form.action, location.origin);
    url.search = new URLSearchParams({q: brandedQuery(normalize(query)), type: 'product', 'options[unavailable_products]': 'show', 'options[prefix]': 'last'}).toString();
    return url;
  }
  function recent() {
    if (!preferencesAllowed()) return [];
    try { const value = JSON.parse(localStorage.getItem(historyKey)); return Array.isArray(value) ? value.filter(q => typeof q === 'string').map(normalize).filter(Boolean).slice(0, 5) : []; } catch { return []; }
  }
  function remember(query) {
    if (!preferencesAllowed()) return;
    const q = normalize(query);
    if (!q) return;
    try { localStorage.setItem(historyKey, JSON.stringify([q, ...recent().filter(item => item.toLowerCase() !== q.toLowerCase())].slice(0, 5))); } catch {}
  }
  async function suggestions(endpoint, query, signal) {
    const key = query.toLowerCase();
    const found = cache.get(key);
    if (found && Date.now() - found.time < 30000) return found.html;
    const url = new URL(endpoint, location.origin);
    url.search = new URLSearchParams({q: query, 'resources[type]': 'product,collection,query', 'resources[limit]': '4', 'resources[limit_scope]': 'each', 'resources[options][unavailable_products]': 'show', section_id: 'bizedeals-predictive-search'}).toString();
    const response = await fetch(url, {signal, headers: {'Accept': 'text/html'}});
    if (!response.ok) throw new Error('Suggestions unavailable');
    const document = new DOMParser().parseFromString(await response.text(), 'text/html');
    const fragment = document.querySelector('[data-search-fragment]');
    if (!fragment) throw new Error('Missing search results');
    fragment.querySelectorAll('script').forEach(script => script.remove());
    const html = fragment.innerHTML;
    cache.set(key, {html, time: Date.now()});
    if (cache.size > 20) cache.delete(cache.keys().next().value);
    return html;
  }
  function prepareResults(root) {
    root.querySelectorAll('.bz-product-card__image').forEach(link => { link.tabIndex = -1; });
    root.querySelectorAll('img').forEach(img => {
      img.loading = 'eager';
      const fail = () => { img.hidden = true; const fallback = img.parentElement.querySelector('.bz-product-card__image-fallback'); if (fallback) fallback.hidden = false; };
      img.addEventListener('error', fail, {once: true});
      if (img.complete && !img.naturalWidth) fail();
    });
    root.querySelectorAll('.bz-product-card').forEach(card => card.checkExpiry?.());
  }
  class BizedealsSearch extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector('input[name="q"]');
      this.form = this.querySelector('form');
      this.results = this.querySelector('.bd-search__suggestions');
      this.status = this.querySelector('[role="status"]');
      this.clear = this.querySelector('.bd-search__clear');
      this.sequence = 0;
      this.clear.hidden = !this.input.value;
      this.input.addEventListener('input', () => this.schedule());
      this.input.addEventListener('focus', () => { if (!this.suppressFocus && this.results.hidden) this.schedule(); });
      this.clear.addEventListener('click', () => { this.input.value = ''; this.schedule(); this.input.focus(); });
      this.form.addEventListener('submit', event => {
        const q = normalize(this.input.value);
        if (!q) { event.preventDefault(); this.input.focus(); return; }
        this.input.value = brandedQuery(q);
        remember(q);
      });
      this.results.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (!link) return;
        const destination = new URL(link.href, location.origin);
        remember(destination.searchParams.get('q') || this.input.value);
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && (!this.results.hidden || this.classList.contains('bd-search--header'))) { event.preventDefault(); event.stopPropagation(); this.hide(); this.suppressFocus = true; this.input.focus(); this.suppressFocus = false; return; }
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        const links = [...this.results.querySelectorAll('a')].filter(a => a.tabIndex !== -1 && a.getClientRects().length);
        if (this.results.hidden || !links.length) return;
        const index = links.indexOf(document.activeElement);
        event.preventDefault();
        if (event.key === 'ArrowUp' && index <= 0) this.input.focus();
        else links[(index + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
      });
      this.outside = event => {
        this.pointerWithin = this.contains(event.target);
        if (!this.pointerWithin) this.hide();
      };
      this.releasePointer = () => {
        clearTimeout(this.pointerTimer);
        this.pointerTimer = setTimeout(() => { this.pointerWithin = false; }, 0);
      };
      document.addEventListener('pointerdown', this.outside);
      document.addEventListener('pointerup', this.releasePointer);
      document.addEventListener('pointercancel', this.releasePointer);
      this.addEventListener('focusout', event => {
        if (this.pointerWithin || this.contains(event.relatedTarget)) return;
        clearTimeout(this.focusTimer);
        this.focusTimer = setTimeout(() => {
          if (!this.pointerWithin && !this.contains(document.activeElement)) this.hide();
        }, 0);
      });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.focusTimer);
      clearTimeout(this.pointerTimer);
      this.controller?.abort();
      document.removeEventListener('pointerdown', this.outside);
      document.removeEventListener('pointerup', this.releasePointer);
      document.removeEventListener('pointercancel', this.releasePointer);
      this.initialized = false;
    }
    hide() { this.sequence++; clearTimeout(this.timer); this.controller?.abort(); this.results.hidden = true; this.input.setAttribute('aria-expanded', 'false'); this.results.removeAttribute('aria-busy'); this.status.textContent = ''; }
    schedule() {
      this.hide();
      const query = normalize(this.input.value);
      this.clear.hidden = !query;
      const start = this.closest('dialog')?.querySelector('.bd-search-start');
      if (start) start.hidden = query.length >= 2;
      if (query.length < 2) {
        this.results.replaceChildren();
        if (this.contains(document.activeElement)) this.showStart();
        return;
      }
      this.timer = setTimeout(() => this.load(query), 220);
    }
    showStart() {
      const template = this.querySelector('template[data-search-start]');
      if (!template) return;
      this.results.replaceChildren(template.content.cloneNode(true));
      renderRecent(this.results, this.form);
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }
    async load(query) {
      const sequence = ++this.sequence;
      this.controller = new AbortController();
      this.status.classList.remove('bd-search-sr');
      this.status.textContent = this.dataset.loading;
      this.results.setAttribute('aria-busy', 'true');
      try {
        const html = await suggestions(this.dataset.suggestUrl, query, this.controller.signal);
        if (sequence !== this.sequence || normalize(this.input.value) !== query) return;
        this.results.innerHTML = html;
        prepareResults(this.results);
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        this.status.textContent = this.dataset.ready;
        this.status.classList.add('bd-search-sr');
      } catch (error) {
        if (error.name === 'AbortError' || sequence !== this.sequence) return;
        this.status.classList.remove('bd-search-sr');
        this.status.textContent = this.dataset.error;
      } finally { if (sequence === this.sequence) this.results.removeAttribute('aria-busy'); }
    }
  }
  if (!customElements.get('bd-search')) customElements.define('bd-search', BizedealsSearch);
  document.querySelectorAll('.bd-smart-menu').forEach(menu => menu.addEventListener('toggle', () => { if (menu.open) document.querySelectorAll('bd-search').forEach(search => search.hide()); }));
  document.addEventListener('focusin', event => {
    if (event.target.closest('bd-search.bd-search--header')) document.querySelectorAll('.bd-smart-menu[open], .bd-mega-menu[open]').forEach(menu => { menu.open = false; });
  });
  document.getElementById('mobile-drawer-input')?.addEventListener('change', () => document.querySelectorAll('bd-search').forEach(search => search.hide()));
  const dialog = document.getElementById('BizedealsSearch');
  let trigger;
  function renderRecent(root, form) {
    const list = root.querySelector('[data-recent-list]');
    if (!list) return;
    list.replaceChildren();
    for (const query of recent()) {
      const link = document.createElement('a');
      link.textContent = query;
      link.href = searchURL(form, query).toString();
      link.addEventListener('click', () => remember(query));
      list.append(link);
    }
    root.querySelector('[data-recent-searches]').hidden = !list.children.length;
  }
  function showRecent() { if (dialog) renderRecent(dialog, dialog.querySelector('form')); }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open-search]');
    if (opener && dialog) {
      trigger = opener;
      const search = dialog.querySelector('bd-search');
      search.input.value = '';
      search.schedule();
      showRecent();
      if (!dialog.open) dialog.showModal();
      document.body.classList.add('bd-search-open');
      dialog.querySelector('input[name="q"]').focus();
    }
    if (event.target.closest('[data-close-search]')) dialog?.close();
    if (event.target.closest('[data-clear-recent]')) { try { localStorage.removeItem(historyKey); } catch {} showRecent(); document.querySelectorAll('bd-search.bd-search--header').forEach(search => { if (!search.results.hidden) search.showStart(); }); }
  });
  dialog?.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  dialog?.addEventListener('keydown', event => { if (event.key === 'Escape' && !event.defaultPrevented) { event.preventDefault(); dialog.close(); } });
  dialog?.addEventListener('close', () => { document.body.classList.remove('bd-search-open'); dialog.querySelector('bd-search')?.hide(); trigger?.focus(); });
  document.querySelectorAll('bd-search-recovery').forEach(async root => {
    try {
      const html = await suggestions(root.dataset.suggestUrl, root.dataset.query);
      const content = root.querySelector('[data-recovery-results]');
      content.innerHTML = html;
      const products = content.querySelectorAll('.bd-suggest-product');
      if (!products.length && !content.querySelector('.bd-suggest-paths a')) return;
      content.querySelector('.bd-suggest-all')?.remove();
      prepareResults(content);
      root.hidden = false;
    } catch {}
  });
  document.querySelectorAll('.bd-search-feature').forEach(card => {
    const image = card.querySelector('img');
    const hide = () => { card.hidden = true; image.removeAttribute('src'); };
    image.addEventListener('error', hide, { once: true });
    if (image.complete && !image.naturalWidth) hide();
    const expires = Number(card.dataset.searchFeatureExpires) * 1000;
    if (!expires) return;
    const check = () => {
      if (Date.now() >= expires) hide();
      else setTimeout(check, Math.min(expires - Date.now() + 50, 2147483647));
    };
    document.addEventListener('visibilitychange', () => { if (!document.hidden && Date.now() >= expires) hide(); });
    check();
  });
  document.querySelectorAll('[data-search-sort]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  document.querySelectorAll('[data-search-layout]').forEach(layout => {
    const sidebar = layout.querySelector('[data-search-sidebar]');
    const content = sidebar.querySelector('[data-search-sidebar-content]');
    const form = content.querySelector('[data-search-facets]');
    const panel = layout.parentElement.querySelector('[data-search-filter-dialog]');
    const target = panel.querySelector('[data-search-filter-target]');
    const opener = layout.querySelector('[data-open-search-filters]');
    const mobile = matchMedia('(max-width: 991px)');
    const min = form.querySelector('[data-price-min]');
    const max = form.querySelector('[data-price-max]');
    const validatePrice = () => {
      if (max) max.setCustomValidity(min?.value && max.value && Number(min.value) > Number(max.value) ? max.dataset.invalid : '');
    };
    const rangeMin = form.querySelector('[data-range-min]');
    const rangeMax = form.querySelector('[data-range-max]');
    const syncRanges = () => {
      validatePrice();
      if (!rangeMin || !rangeMax) return;
      rangeMin.value = min.value || '0';
      rangeMax.value = max.value || rangeMax.max;
      rangeMin.style.zIndex = Number(rangeMin.value) === Number(rangeMax.max) ? '3' : '1';
      rangeMax.style.zIndex = '2';
    };
    min?.addEventListener('input', syncRanges);
    max?.addEventListener('input', syncRanges);
    rangeMin?.addEventListener('input', () => {
      min.value = String(Math.min(Number(rangeMin.value), Number(rangeMax.value)));
      syncRanges();
    });
    rangeMax?.addEventListener('input', () => {
      max.value = String(Math.max(Number(rangeMax.value), Number(rangeMin.value)));
      syncRanges();
    });
    syncRanges();
    form.querySelectorAll('[data-filter-more]').forEach(button => {
      const values = document.getElementById(button.getAttribute('aria-controls'));
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
        values.toggleAttribute('data-expanded', expanded);
      });
    });
    form.querySelectorAll('input[type="checkbox"]').forEach(input => input.addEventListener('change', () => {
      if (!mobile.matches) form.requestSubmit();
    }));
    form.addEventListener('formdata', event => {
      [min, max].filter(Boolean).forEach(input => { if (!input.value) event.formData.delete(input.name); });
    });
    const positionFilters = () => {
      if (!mobile.matches && panel.open) panel.close();
      (mobile.matches ? target : sidebar).append(content);
      content.querySelector('.bd-search-departments').open = !mobile.matches;
      opener.hidden = !mobile.matches;
    };
    opener.addEventListener('click', () => {
      document.querySelectorAll('bd-search').forEach(search => search.hide());
      panel.showModal();
      document.body.classList.add('bd-search-filters-open');
    });
    panel.querySelector('[data-close-search-filters]').addEventListener('click', () => panel.close());
    panel.addEventListener('close', () => { document.body.classList.remove('bd-search-filters-open'); if (mobile.matches) opener.focus(); });
    panel.addEventListener('click', event => {
      if (event.target !== panel) return;
      const bounds = panel.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right) panel.close();
    });
    mobile.addEventListener('change', positionFilters);
    layout.dataset.enhanced = 'true';
    positionFilters();
  });
  document.querySelectorAll('.bd-search-filter').forEach(details => details.addEventListener('toggle', () => {
    if (details.open) document.querySelectorAll('.bd-search-filter[open]').forEach(other => { if (other !== details) other.open = false; });
  }));
  document.querySelectorAll('[data-search-carousel]').forEach(root => {
    const track=root.querySelector('[data-carousel-track]');
    const prev=root.querySelector('[data-carousel-prev]');
    const next=root.querySelector('[data-carousel-next]');
    const update=()=>{prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
    root.querySelectorAll('[data-carousel-prev],[data-carousel-next]').forEach(button=>{button.hidden=false;button.addEventListener('click',()=>track.scrollBy({left:(button===prev?-1:1)*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));});
    track.addEventListener('scroll',update,{passive:true});
    new ResizeObserver(update).observe(track);update();
  });

  function refreshPrivacyChoices() {
    if (!preferencesAllowed()) { try { localStorage.removeItem(historyKey); } catch {} }
    showRecent();
    document.querySelectorAll('bd-search.bd-search--header').forEach(search => {
      if (!search.results.hidden && !search.input.value.trim()) search.showStart();
    });
  }
  document.addEventListener('visitorConsentCollected', refreshPrivacyChoices);
  if (window.Shopify?.customerPrivacy) refreshPrivacyChoices();
  else window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], error => {
    if (!error) refreshPrivacyChoices();
  });
})();